import { useState, useEffect } from "react"
import { useHistory } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/Search'

import Table from '@base/Table'

export const QuantitativoCartoesTableView = (props) => {
	const processo = props.processo;
	const escola = props.escola;

	const [cartoesTableData, setCartoesTableData] = useState([]);

	const columns = [
		{ label: 'Nível', name: 'nivel', func: null, key: true, ordering: false },
		{ label: 'Previstos', name: 'cartoesPrevistos', func: null, key: false, ordering: false },
		{ label: 'Informados no D.E', name: 'cartoesInformadosDE', func: null, key: false, ordering: false },
		{ label: 'Recebidos', name: 'cartoesRecebidos', func: null, key: false, ordering: false },
		{ label: 'Recebidos (Únicos)', name: 'cartoesRecebidosSemDuplicidade', func: null, key: false, ordering: false },
		{ label: 'Digitalizados', name: 'cartoesDigitalizados', func: null, key: false, ordering: false },
		{ label: 'Digitados', name: 'cartoesDigitados', func: null, key: false, ordering: false }
	];

	function redirecionarParaPaginaDeCartoes(nivel) {
		history.push({
			pathname: "/" + processo + "/escola/" + escola.codigoInep + "/cartoes",
			state: { nivel: nivel }
		});
	}

	function formatoQtdInformadaDE(qtd) {
		return qtd ? qtd : 'não recebido';
	}

	function formatoQtd(qtd) {
		return qtd ? qtd : 0;
	}

	const actionsCartoes = [
		{
			name: () => "Listar Cartões",
			func: redirecionarParaPaginaDeCartoes,
			icon: <SearchIcon />,
			disabled: () => false,
		},
	]

	useEffect(() => {


    if (escola !== undefined && escola.cartoes !== undefined) {
			setCartoesTableData([
				{
					nivel: 1,
					cartoesPrevistos: formatoQtd(escola.cartoes.n1.qtdPrevista),
					cartoesInformadosDE: formatoQtdInformadaDE(escola.cartoes.n1.qtdInformadaDE),
					cartoesRecebidos: formatoQtd(escola.cartoes.n1.qtdRecebida),
					cartoesRecebidosSemDuplicidade : formatoQtd(escola.cartoes.n1.qtdeRecebidaIgnorandoDuplicidades),
					cartoesDigitados: formatoQtd(escola.cartoes.n1.qtdDigitada),
					cartoesDigitalizados: formatoQtd(escola.cartoes.n1.qtdDigitalizada)
				},
				{
					nivel: 2,
					cartoesPrevistos: formatoQtd(escola.cartoes.n2.qtdPrevista),
					cartoesInformadosDE: formatoQtdInformadaDE(escola.cartoes.n2.qtdInformadaDE),
					cartoesRecebidos: formatoQtd(escola.cartoes.n2.qtdRecebida),
					cartoesRecebidosSemDuplicidade : formatoQtd(escola.cartoes.n2.qtdeRecebidaIgnorandoDuplicidades),
					cartoesDigitados: formatoQtd(escola.cartoes.n2.qtdDigitada),
					cartoesDigitalizados: formatoQtd(escola.cartoes.n2.qtdDigitalizada)
				},
				{
					nivel: 3,
					cartoesPrevistos: formatoQtd(escola.cartoes.n3.qtdPrevista),
					cartoesInformadosDE: formatoQtdInformadaDE(escola.cartoes.n3.qtdInformadaDE),
					cartoesRecebidos: formatoQtd(escola.cartoes.n3.qtdRecebida),
					cartoesRecebidosSemDuplicidade : formatoQtd(escola.cartoes.n3.qtdeRecebidaIgnorandoDuplicidades),
					cartoesDigitados: formatoQtd(escola.cartoes.n3.qtdDigitada),
					cartoesDigitalizados: formatoQtd(escola.cartoes.n3.qtdDigitalizada)
				}
			]);
		}

	}, [escola]);

	let history = useHistory();
	return (

		<>
			<br />
			<Grid container spacing={5}>
				<Grid item xs={12}>
					<Table style={{ marginTop: 0 }}
						columns={columns}
						tableData={cartoesTableData}
						actions={actionsCartoes}
						loading={false}
					/>
				</Grid>
			</Grid>

		</>
	);
}

export default QuantitativoCartoesTableView;
